export default __webpack_public_path__ + "static/media/Erin_Taylor_AHV_In_Moms_We_Trust.b43d82ea.jpg";